import { useLayoutEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Outlet, useParams } from 'react-router';

import NotFound from '@/components/pages/NotFound/NotFound';
import { setDeskId } from '@/redux/session/actions';
import { isUuid } from '@/util/util';

/**
 * Wrapper component that extracts deskId from URL params and syncs it to Redux store.
 * Validates that deskId is a valid UUID before dispatching.
 * Renders child routes via Outlet, or NotFound if deskId is invalid.
 */
const DeskIdProvider = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-restricted-syntax -- Infrastructure: syncs URL deskId to Redux
  const { deskId } = useParams();

  // A layout effect: it must beat the page view of the page underneath.
  useLayoutEffect(() => {
    if (deskId && isUuid(deskId)) {
      dispatch(setDeskId(deskId));
    }
  }, [dispatch, deskId]);

  // Validate deskId is a valid UUID - check after hooks
  if (deskId && !isUuid(deskId)) {
    return <NotFound entity="environment" value={deskId} />;
  }

  return <Outlet />;
};

export default DeskIdProvider;
